module.exports = __webpack_public_path__ + "static/media/backgroundimage.89080bea.png";